import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import {
  ActionIconContainer,
  AddFormButton,
  CustomLoader,
  FilterButton,
  RedButton,
} from "../../shared/components/TableElements";
import {
  FormGroupLabel,
  FormItem,
} from "../../shared/components/form/FormElements";
import { formInputStyles } from "../../shared/constants/styles";
import Error from "@/shared/components/form/Error";

const AddServiceTaskCategoryPopup = ({
  showPopup,
  setShowPopup,
  categoryData,
  onSave,
  onDelete,
  onClose,
  isCreateNew = false,
  error,
  isSaving = false,
  isDeleting = false,
}) => {
  const { t } = useTranslation("common");
  const [serviceTaskCategory, setServiceTaskCategory] = useState(
    categoryData?.label || ""
  );
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

  const handleSave = () => {
    if (serviceTaskCategory.trim() && !isSaving && !isDeleting) {
      onSave({
        categoryName: serviceTaskCategory.trim(),
        categoryId: categoryData?.value,
        isNew: isCreateNew,
      });
    }
  };

  const handleDeleteClick = () => {
    if (!isSaving && !isDeleting) {
      setShowDeleteConfirmation(true);
    }
  };

  const handleConfirmDelete = () => {
    if (!isSaving && !isDeleting) {
      onDelete(categoryData?.value);
    }
  };

  const handleCancelDelete = () => {
    setShowDeleteConfirmation(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSave();
    } else if (e.key === "Escape") {
      setShowPopup(false);
    }
  };

  const handleClose = () => {
    setShowPopup(false);
    if (error && typeof onClose === "function") {
      onClose();
    }
  };

  return (
    <Modal
      show={showPopup}
      size="md"
      centered
      backdropClassName="custom-backdrop"
    >
      <Modal.Header>
        <h4>
          {isCreateNew
            ? t("add_service_task_category")
            : t("edit_service_task_category")}
        </h4>
        <div className="d-flex justify-content-end">
          <ActionIconContainer onClick={handleClose}>
            <i className="fi fi-rr-cross-small" />
          </ActionIconContainer>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div>
          <FormGroupLabel className="m-0">
            {t("service_task_category")}
          </FormGroupLabel>
          <FormItem disabled={isSaving || isDeleting}>
            <input
              type="text"
              name="serviceTaskCategory"
              value={serviceTaskCategory}
              onChange={(e) => setServiceTaskCategory(e.target.value)}
              onKeyDown={handleKeyPress}
              placeholder={t("service_task_category")}
              style={formInputStyles}
              disabled={isSaving || isDeleting}
            />
          </FormItem>
          {error && <Error error={error} />}

          {/* Delete Confirmation Box */}
          {showDeleteConfirmation && (
            <div
              style={{
                backgroundColor: "#fff5f5",
                border: "1px solid #dc3545",
                borderRadius: "4px",
                padding: "12px",
                marginTop: "16px",
              }}
            >
              <p
                style={{
                  color: "#dc3545",
                  margin: "0 0 12px 0",
                  fontSize: "14px",
                }}
              >
                {t("delete_service_task_category_confirm")}
              </p>
              <div style={{ display: "flex", gap: "8px" }}>
                <RedButton
                  type="button"
                  onClick={handleConfirmDelete}
                  disabled={isSaving || isDeleting}
                >
                  {isDeleting ? <CustomLoader /> : t("delete")}
                </RedButton>
                <FilterButton
                  type="button"
                  onClick={handleCancelDelete}
                  disabled={isSaving || isDeleting}
                >
                  {t("cancel")}
                </FilterButton>
              </div>
            </div>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="d-flex justify-content-between w-100">
          <div>
            {!isCreateNew && !showDeleteConfirmation && (
              <RedButton
                type="button"
                onClick={handleDeleteClick}
                disabled={isSaving || isDeleting}
              >
                {t("delete")}
              </RedButton>
            )}
          </div>
          <AddFormButton
            id="save-form-button"
            type="button"
            onClick={handleSave}
            disabled={
              isSaving ||
              isDeleting ||
              showDeleteConfirmation ||
              !serviceTaskCategory.trim()
            }
          >
            {isSaving ? <CustomLoader /> : t("save")}
          </AddFormButton>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddServiceTaskCategoryPopup;
